import { render, staticRenderFns } from "./PickedupMenu.vue?vue&type=template&id=7f27270d&scoped=true&"
import script from "./PickedupMenu.vue?vue&type=script&lang=js&"
export * from "./PickedupMenu.vue?vue&type=script&lang=js&"
import style0 from "./PickedupMenu.vue?vue&type=style&index=0&id=7f27270d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27270d",
  null
  
)

export default component.exports